/* eslint-disable no-unused-vars */
import { createAsyncThunk } from '@reduxjs/toolkit'
import useJwt from '@src/auth/jwt/useJwt'
import { jwtDecode as jwt_decode } from 'jwt-decode'
import { setPermissions } from '../permissions/permissionsSlice'
// ** utils
import { getHomeRouteForLoggedInUser } from '@utils'

// ** components
import { ToastContent } from '@src/components/toast'
import { Check, X } from 'react-feather'
import toast from 'react-hot-toast'
// Field Errors
const fieldErrors = (err) => {
  const errors = err?.response?.data
  if (errors) {
    Object.keys(errors).map((key) => {
      toast((t) => (
        <ToastContent
          t={t}
          name={key}
          icon={<X size={14} />}
          color="danger"
          msg={
            errors.msg ||
            errors?.detail ||
            errors[key][0] ||
            errors?.non_field_errors?.[0]
          }
        />
      ))
    })
  }
}
// Actions
export const login = createAsyncThunk(
  'auth/login',
  async ({ data, ability, navigate }, { rejectWithValue, dispatch }) => {
    try {
      const response = await useJwt.login(data)
      if (response?.data?.email) {
        navigate('/auth')
        return response?.data
      }
      const { access, refresh } = response?.data
      useJwt.setToken(access)
      useJwt.setRefreshToken(refresh)
      const decoded = jwt_decode(access)

      const providerUser = decoded?.is_provider
      const provider_avatar = decoded?.avatar
      if (providerUser) {
        localStorage.setItem('avatar', provider_avatar)

        dispatch(setPermissions(decoded?.permissions))
        useJwt.setUserData({ role: providerUser, decoded })
        const userData = useJwt.getUserData()
        toast((t) => (
          <ToastContent
            t={t}
            name={decoded?.email}
            icon={<Check size={14} />}
            color="success"
            msg={'You have successfully logged in'}
          />
        ))
        ability.update(userData.ability)
        navigate(getHomeRouteForLoggedInUser(providerUser))
      }
      if (!providerUser) {
        localStorage.clear()
        toast((t) => (
          <ToastContent
            t={t}
            name={decoded?.email}
            icon={<X size={14} />}
            color="danger"
            msg={'You do not have permission to perform this action'}
          />
        ))
      }
      return decoded
    } catch (err) {
      const errors = err?.response?.data
      if (errors && err?.response.status !== 401) {
        Object.keys(errors).map((key) => {
          toast((t) => (
            <ToastContent
              t={t}
              name={'Error'}
              icon={<X size={14} />}
              color="danger"
              msg={errors.msg}
            />
          ))
        })
      } else if (err?.response.status === 401) {
        toast((t) => (
          <ToastContent
            t={t}
            name={'Login Error'}
            icon={<X size={14} />}
            color="danger"
            msg={errors?.detail}
          />
        ))
      }
      return rejectWithValue(err?.response?.data || err.message)
    }
  }
)
export const signup = createAsyncThunk(
  'auth/signup',
  async ({ data, successCb, failureCb }, { rejectWithValue, dispatch }) => {
    try {
      const response = await useJwt.signup(data)
      if (response?.data?.email) {
        toast((t) => (
          <ToastContent
            t={t}
            name={'Signup Successful'}
            icon={<Check size={14} />}
            color="success"
            msg={
              'You have successfully signed up. Check your email to set a password'
            }
          />
        ))
        successCb()
        return response?.data
      }
      return response?.data
    } catch (err) {
      failureCb()
      toast((t) => (
        <ToastContent
          t={t}
          name={'Error'}
          icon={<X size={14} />}
          color="danger"
          msg={err?.response?.data?.msg}
        />
      ))
      return rejectWithValue(err?.response?.data || err.message)
    }
  }
)
//**  Create New Password    */
export const createNewPasswordAction = createAsyncThunk(
  'auth/createNewPasswordAction',
  async ({ data, callback, navigate }, { rejectWithValue }) => {
    try {
      const response = await useJwt.createNewPassword(data)
      toast((t) => (
        <ToastContent
          t={t}
          name="Password Updated Successfully"
          icon={<Check size={14} />}
          color="success"
          msg={response?.data?.message}
        />
      ))
      callback()
      return response?.data
    } catch (err) {
      fieldErrors(err)
      return rejectWithValue(err?.response?.data)
    }
  }
)

//**  Create New Password    */
export const forgotPasswordAction = createAsyncThunk(
  'auth/forgotPassword',
  async ({ data, callback }, { rejectWithValue }) => {
    try {
      const response = await useJwt.forgotPassword(data)
      toast((t) => (
        <ToastContent
          t={t}
          name="Reset link sent successfully"
          icon={<Check size={14} />}
          color="success"
          msg={response?.data?.message}
        />
      ))
      callback()
      return response?.data
    } catch (err) {
      toast((t) => (
        <ToastContent
          t={t}
          name="Invalid Email"
          icon={<X size={14} />}
          color="danger"
          msg={err?.response?.data?.msg}
        />
      ))
      return rejectWithValue(err?.response?.data)
    }
  }
)

//**  Create New Password    */
export const ResetPasswordAction = createAsyncThunk(
  'auth/ResetPassword',
  async ({ data, callback }, { rejectWithValue }) => {
    try {
      const response = await useJwt.ResetPassword(data)
      toast((t) => (
        <ToastContent
          t={t}
          name="Password Updated Successfully"
          icon={<Check size={14} />}
          color="success"
          msg={response?.data?.message}
        />
      ))
      callback()
      return response?.data
    } catch (err) {
      fieldErrors(err)
      return rejectWithValue(err?.response?.data)
    }
  }
)

export const send2FaAuthCodeAction = createAsyncThunk(
  'auth/send2FaAuthCode',
  async (
    { data, ability, navigate, callback },
    { dispatch, rejectWithValue }
  ) => {
    try {
      const response = await useJwt.send2FaAuthCode(data)

      const { access, refresh } = response?.data
      useJwt.setToken(access)
      useJwt.setRefreshToken(refresh)
      const decoded = jwt_decode(access)

      const providerUser = decoded?.is_provider
      const provider_avatar = decoded?.avatar
      if (providerUser) {
        localStorage.setItem('avatar', provider_avatar)
        dispatch(setPermissions(decoded?.permissions))
        useJwt.setUserData({ role: providerUser, decoded })
        const userData = useJwt.getUserData()
        toast((t) => (
          <ToastContent
            t={t}
            name={decoded?.email}
            icon={<Check size={14} />}
            color="success"
            msg={'You have successfully logged in'}
          />
        ))
        ability.update(userData.ability)

        navigate(getHomeRouteForLoggedInUser(providerUser))
      }
      if (!providerUser) {
        localStorage.clear()
        toast((t) => (
          <ToastContent
            t={t}
            name={decoded?.email}
            icon={<X size={14} />}
            color="danger"
            msg={'You do not have permission to perform this action'}
          />
        ))
      }
      return decoded
    } catch (err) {
      callback()
      toast((t) => (
        <ToastContent
          t={t}
          name={'Error'}
          icon={<X size={14} />}
          color="danger"
          msg={err?.response?.data?.msg}
        />
      ))
      return rejectWithValue(err?.response?.data)
    }
  }
)
